import { useEffect } from 'react';

import { nr } from '~/common';

import { useMediaPlayer } from '../MediaPlayerProvider';

export function useLogCurrentSource() {
  const { player, mediaId } = useMediaPlayer();
  useEffect(() => {
    if (player !== null) {
      player.on('loadedmetadata', () => {
        const mediaSource = player.currentSource();
        nr.addAction(nr.BRIGHTCOVE_MEDIA_SRC_LOADED, { mediaId, src: mediaSource });
      });
    }
  }, [mediaId, player]);
}
